import { LucideIcon } from "lucide-react";

interface ContactBadgeProps {
  icon: LucideIcon;
  label: string;
  value: string;
  href?: string;
  delay?: number;
}

const ContactBadge = ({
  icon: Icon,
  label,
  value,
  href,
  delay = 0,
}: ContactBadgeProps) => {
  const content = (
    <div
      className="group relative flex items-center gap-3 px-5 py-3.5 bg-card rounded-xl shadow-soft border border-border/50 hover:border-primary/40 transition-all duration-300 hover:-translate-y-1 hover:shadow-badge animate-scale-in overflow-hidden"
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Gradient overlay on hover */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      <div className="relative w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center group-hover:bg-blue-700 transition-colors duration-300">
        <Icon className="w-5 h-5 text-white" />
      </div>
      <div className="relative flex flex-col">
        <span className="text-muted-foreground text-xs font-medium uppercase tracking-wide">
          {label}
        </span>
        <span className="font-bold text-foreground text-base md:text-lg group-hover:text-primary transition-colors duration-300">
          {value}
        </span>
      </div>
    </div>
  );

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="block"
      >
        {content}
      </a>
    );
  }

  return content;
};

export default ContactBadge;
